import { AttributeKey } from '@ps/poker-games-tile-mappers';
import classNames from 'clsx';
import React from 'react';

import { stripHTML } from '@swf/poker';

import { TileType } from '../../types/common';
import type { HGPokerGameTile } from '../../types/common';
import Table from '../Table/Table';

import { cashGameColumns, tournamentColumns } from './Columns/Columns';
import styles from './GameList.scss';
import GameListItem from './GameListItem/GameListItem';

export interface Props {
  games: HGPokerGameTile[];
  tileType: TileType;
  clubId: string;
}

const GameList: React.FC<Props> = ({ games, tileType, clubId }) => {
  const columns = tileType === TileType.Cash ? cashGameColumns : tournamentColumns;
  const data = games.map((game) => {
    const { attributes, name } = game;
    const attrs = attributes.reduce(
      (
        previous: { [key: string]: string },
        current: { name: string; value: string; key: AttributeKey }
      ) =>
        Object.assign(previous, {
          [AttributeKey[current.key]]: current.value
        }),
      {}
    );
    const { playersSeated, maxPlayers } = game;
    const players =
      playersSeated !== undefined ? `${playersSeated}/${maxPlayers}` : `${maxPlayers}`;

    return {
      ...game,
      ...attrs,
      name: stripHTML(name) ?? undefined,
      players: (
        <div className={classNames({ [styles.fullGame]: playersSeated === maxPlayers })}>
          {players}
        </div>
      )
    };
  });

  return (
    <div className={styles.container} data-testid={`game-list-${clubId}-${tileType}`}>
      <Table columns={columns} data={data} rowComponent={GameListItem} />
    </div>
  );
};

export default GameList;
